import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import logo from "../../../assets/images/fullLogo.svg";
import darkThemeLogo from "../../../assets/images/darkthemelogo.svg";
import hamburgerMenu from "../../../assets/icons/hamburgerMenu.svg";
import { Link } from "react-router-dom";
import { FiChevronDown, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import AboutMegaMenu from "./AboutMegaMenu/AboutMegaMenu";
import MobileNav from "./MobileNav/MobileNav";
import RequestCallModal from "../RequestCallModal/RequestCallModal";

const Navbar = ({ theme = "light" }) => {
  const { t, i18n } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isRequestCallOpen, setIsRequestCallOpen] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);
  const languageRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const onDocClick = (event) => {
      if (!languageRef.current?.contains(event.target)) {
        setIsLangOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 2);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const isScrolledTheme = isScrolled || theme === "dark";

  return (
    <div className={`navbar ${isScrolled ? "navbar--glassed" : ""} ${isScrolledTheme ? "navbar--darkLinks" : ""}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-left" onClick={closeMobileMenu}>
          <img
            className="logo"
            src={isScrolledTheme ? darkThemeLogo : logo}
            alt="Logo"
          />
        </Link>

        <button
          className="mobile-menu-toggle"
          type="button"
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
          onClick={toggleMobileMenu}
        >
          <img src={hamburgerMenu} alt="" aria-hidden="true" />
        </button>

        <div className="navbar-center">
          <ul className="nav-links">
            <li className="nav-item--mega">
              <Link to="/about">
                {t("navbar.aboutUs")} <FiChevronDown className="nav-icon" />
              </Link>
              <AboutMegaMenu />
            </li>

            <li>
              <Link to="/products">
                {t("navbar.products")}
              </Link>
            </li>

            <li>
              <Link to="/allsolutions">
                {t("navbar.solutions")}
              </Link>
            </li>

            <li>
              <Link to="/services">
                {t("navbar.services")}
              </Link>
            </li>

            <li>
              <Link to="/sectors">
                {t("navbar.sectors")}
              </Link>
            </li>

            <li>
              <Link to="/allprojects">{t("navbar.projects")}</Link>
            </li>

            <li>
              <Link to="/estimator">
                {t("navbar.estimator")}
              </Link>
            </li>
          </ul>

          <div className="navdivider"></div>
          <div className="navbar-right">
            <div className="language language-dropdown" ref={languageRef}>
              <button
                type="button"
                className="language-trigger"
                onClick={() => setIsLangOpen((prev) => !prev)}
              >
                {String(i18n.language || "en").toUpperCase()} <FiChevronDown className="nav-icon" />
              </button>
              {isLangOpen ? (
                <div className="language-menu">
                  {[
                    { code: "en", label: "English" },
                    { code: "ar", label: "Arabic" },
                    { code: "ku", label: "Kurdish" },
                  ].map((lang) => (
                    <button
                      key={lang.code}
                      type="button"
                      className={`language-menu-item ${i18n.language === lang.code ? "is-active" : ""}`}
                      onClick={() => {
                        i18n.changeLanguage(lang.code);
                        localStorage.setItem("irqgyp_lang", lang.code);
                        setIsLangOpen(false);
                      }}
                    >
                      {lang.label}
                    </button>
                  ))}
                </div>
              ) : null}
            </div>

            <button
              className="buttongyp"
              type="button"
              onClick={() => setIsRequestCallOpen(true)}
            >
              {t("navbar.requestCall")}
            </button>
          </div>
        </div>

        <MobileNav
          isOpen={isMobileMenuOpen}
          onClose={closeMobileMenu}
          t={t}
          i18n={i18n}
          onRequestCall={() => {
            closeMobileMenu();
            setIsRequestCallOpen(true);
          }}
        />
      </div>
      <RequestCallModal
        isOpen={isRequestCallOpen}
        onClose={() => setIsRequestCallOpen(false)}
      />
    </div>
  );
};

export default Navbar;